import { QueryClient, QueryClientProvider } from 'react-query';
import { UserProps } from '@osmosis/shared/types/user';
import { LanguageCode } from '@osmosis/shared/languages';
import Footer, { Props as FooterProps } from './Footer';
import { LanguageProvider } from '../../context/LanguageProvider';
import { IntlMessagesType } from '../../types/poeditor';
import ClientFooterColumns from './FooterColumns/ClientFooterColumns';

export type Props = FooterProps & {
  user?: UserProps;
  bestLanguage?: LanguageCode;
  intlMessages?: IntlMessagesType;
};

const queryClient = new QueryClient({});

/**
 * Footer client wrapper.
 */
const FooterWrapper = ({
  isPagesRouter,
  user,
  bestLanguage,
  intlMessages,
}: Props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider
        user={user}
        bestLanguage={bestLanguage}
        serverIntlMessages={intlMessages}
      >
        <Footer isPagesRouter={isPagesRouter}>
          <ClientFooterColumns />
        </Footer>
      </LanguageProvider>
    </QueryClientProvider>
  );
};

export default FooterWrapper;
